<template>
  <div>

    <v-card>
      <v-card-title>Listado de tipos de Descarga</v-card-title>
      <v-card-text>

        <botonera :botones="botones" alinear="right"
        @crear="dialog = !dialog"
        ></botonera>


        
      </v-card-text>
    </v-card>

    <datatable :cabeceras="tipoDescargasListHeaders" :items="tipoDescargasListBody" titulo="Listado de Tipos de Descargas" label="Escriba Para buscar Tipo de Descargas" icono="list" color_icono="azul"
    :tachar="false"
    :acciones="['editar','eliminar']"
    @editar="editTipoDescarga($event)"
    @eliminar="deleteTipoDescarga($event)">
    </datatable>

    <!-- <v-data-table 
        :headers="tipoDescargasListHeaders"
        :items="tipoDescargasListBody"
        class="elevation-1"
        no-data-text="No hay tipos de descarga"
        :search="search"
    >
      <template v-slot:[`item.actions`]="{item}">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-icon
              medium
              class="mr-2"
              @click="editTipoDescarga(item)"
              v-on="on"
            >
              mdi-pencil
            </v-icon>
          </template>
          <span>Editar Tipo Descarga</span>
        </v-tooltip>
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-icon
              medium
              @click="deleteTipoDescarga(item)"
              v-on="on"
            >
            mdi-delete
            </v-icon>
          </template>
          <span>Eliminar Tipo Descarga</span>
        </v-tooltip>
      </template>
    </v-data-table> -->

    <!-- Modal Nuevo Tipo Descarga -->
    <v-dialog
      v-model="dialog"
      width="800px"
      @click:outside = "closeModal"
    >
      <v-card>
        <v-card-title class="blue darken-1">{{ title }}</v-card-title>
        <v-card-text>
          <v-row class="mx-2">
            <v-col
              class="align-center justify-space-between"
              cols="6"
            >
              <v-text-field
                prepend-icon="mdi-barcode"
                placeholder="Nombre"
                v-model="tipoDescarga.nombre"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
              <v-btn
                @click="closeModal"
              >Cerrar</v-btn>
              <v-btn
                color="primary"
                @click="saveTipoDescarga"
              >Grabar</v-btn>
        </v-card-actions>
              
      </v-card>
    </v-dialog>
    <!-- / Modal -->
    
    <v-snackbar
      v-model="snackbar"
      :timeout="5000"
      :color="color"
    >
      {{ validation_message }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Cerrar
        </v-btn>
      </template>
    </v-snackbar>

  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex'

  export default {
    data: () => ({
      title: 'Nuevo Tipo de Descarga',
      color: 'green',
      snackbar: false,
      errors: [],
      validation_message: '',
      success: null,
      search: null,
      file: null,
      dialog: false,
      tipoDescargaIndex: -1,
      tipoDescarga: {
        id: 0,
        nombre: '',
      },
      tipoDescargasListHeaders: [
        {
          text: 'Id',
          align: 'center',
          sortable: true,
          value: 'id',
          class: "blue-grey darken-4 white-text"
        },
        {
          text: 'Nombre',
          align: 'center',
          sortable: true,
          value: 'nombre',
          class: "blue-grey darken-4 white-text"
        },
        {
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'actions',
          class: "blue-grey darken-4 white-text"
        },
      ],
      tipoDescargasListBody: [],
      botones:[
        {boton:'crear',tooltip:'Nuevo Tipo Descarga'},
        //{boton:'cargar',tooltip:'Carga Masiva'},
        //{boton:'eliminar',tooltip:'Borrar Todo'}
      ]
    }),
    mounted() {
      this.loadTipoDescargas();
    },
    methods:{
      async loadTipoDescargas(){
        this.mostrarLoading('Cargando listado de tipos de descarga...')
        let url = `${this.base_url}tipo_descargas`;
        await this.axios.get(url, this.headers).then((response)=>{
          this.tipoDescargasListBody = response.data;
          this.ocultarLoading()
        }).catch((error)=>{
          console.log(error);
          this.ocultarLoading();
        });
      },
      async saveTipoDescarga(){
        // validation
        this.errors = [];
        if(!this.tipoDescarga.nombre){
          this.errors.push("Debe indicar nombre");
        }else if(this.tipoDescarga.nombre.length > 20){
          this.errors.push("Tamaño máximo nombre: 20 caracteres");
        }
        if(this.errors.length > 0){
          this.validation_message = this.errors.join();
          this.showSnackBar(true);
          return;
        }
        let url = `${this.base_url}tipo_descargas`;
        let tipoDescargaData = {
          'nombre': this.tipoDescarga.nombre,
        };
        if(this.tipoDescarga.id > 0){
          url = url + "/" + this.tipoDescarga.id;
          await this.axios.put(url, tipoDescargaData, this.headers).then((response)=>{
            let index = this.tipoDescargasListBody.map(tipoDescarga => {
              return tipoDescarga.id;
            }).indexOf(this.tipoDescarga.id);
            this.tipoDescargasListBody.splice(index, 1, response.data);
            this.showSnackBar(false);
          }).catch((error)=>{
            this.validation_message = error;
            this.showSnackBar(true);
          });
        }else{
          await this.axios.post(url, tipoDescargaData, this.headers).then((response)=>{
              this.tipoDescargasListBody.push(response.data);
              this.showSnackBar(false);
          }).catch((error)=>{
              this.errors = error.response.data;
              this.validation_message = this.errors.join();
              this.showSnackBar(true);
          });
        }
        this.cleanForm();
      },
      editTipoDescarga(item) {
        this.tipoDescargaIndex = this.tipoDescargasListBody.indexOf(item);
        this.tipoDescarga = Object.assign({}, item);
        this.dialog = true;
        this.title = "Editar Tipo de Descarga";
      },
      async deleteTipoDescarga(item) {
        this.$confirm('Desea borrar este tipo de descarga?').then(res => {
          if(res){
            let url = `${this.base_url}tipo_descargas/${item.id}`;
            this.axios.delete(url, this.headers).then((response)=>{
              console.log(response);
              const index = this.tipoDescargasListBody.indexOf(item);
              this.tipoDescargasListBody.splice(index, 1);
              this.showSnackBar(false);
            }).catch((error)=>{
              this.validation_message = error;
              this.showSnackBar(true);
            });
          }
        });
      },
      showSnackBar(error){
        if(error){
          this.color = 'red';
        }else{
          this.color = 'green';
          this.validation_message = "Ejecutado exitosamente!";
        }
        this.snackbar = true;
      },
      closeModal(){
        this.cleanForm();
        this.dialog = false;
        this.error = null;
        this.title = "Nuevo Tipo de Descarga";
      },
      cleanForm(){
        this.tipoDescarga = {
          id: 0,
          nombre: '',
        };
        this.dialog = false;
      },
      ...mapMutations(['actualizarBaseUrl', 'mostrarLoading', 'ocultarLoading']),
    },
    computed:{
      ...mapState(['loading', 'base_url', 'headers']),
      
    },
    components:{
      
    }
  }
</script>